// extracted by mini-css-extract-plugin
module.exports = {"takeA":"CharacterSheetRest_takeA_OZeqj"};